import { FC } from "react";
import { PageHeader } from "../../components/PageHeader";
import { TranslationUpdater } from "../../modules/TranslationUpdater";
import "./style.css";

export const UpdateTranslationsPage: FC = () => {
  return (
    <div className="update-translation">
      <PageHeader
        header="Update translations"
        description="Choose environment to update translations"
      />
      <TranslationUpdater />
    </div>
  );
};
